import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Public/Header';
import Footer from '../components/Public/Footer';
import { SITE } from '../config/site';

export default function PrivacyPage() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - {SITE.name}</title>
        <meta name="description" content={`Privacy Policy for ${SITE.name}`} />
        <link rel="canonical" href={`https://${SITE.domain}/privacy`} />
      </Helmet>

      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
          <Container maxWidth="md">
            <Paper elevation={2} sx={{ p: 4 }}>
              <Typography variant="h3" component="h1" gutterBottom>
                Privacy Policy
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                Last updated: {new Date().toLocaleDateString()}
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                1. Information We Collect
              </Typography>
              <Typography paragraph>
                We collect information you provide directly to us, including when you create an
                account, upload recordings, or contact us for support. This may include your name,
                email address, and organization information.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                2. How We Use Your Information
              </Typography>
              <Typography paragraph>
                We use the information we collect to provide, maintain, and improve our services,
                including processing your meeting recordings and generating transcripts. We also use
                it to communicate with you and respond to your requests.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                3. Data Security
              </Typography>
              <Typography paragraph>
                We implement appropriate technical and organizational measures to protect your
                personal information against unauthorized access, alteration, disclosure, or
                destruction. All data is isolated by organization to ensure privacy.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                4. Data Retention
              </Typography>
              <Typography paragraph>
                We retain your information for as long as your account is active or as needed to
                provide you services. You may request deletion of your data at any time by
                contacting us at {SITE.supportEmail}.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                5. Third-Party Services
              </Typography>
              <Typography paragraph>
                We may use third-party services to help us operate our business, such as cloud
                storage providers and analytics services. These third parties have access to your
                information only to perform specific tasks on our behalf.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                6. Your Rights
              </Typography>
              <Typography paragraph>
                You have the right to access, update, or delete your personal information at any
                time. You can manage your account settings or contact us for assistance.
              </Typography>

              <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
                7. Contact Us
              </Typography>
              <Typography paragraph>
                If you have any questions about this Privacy Policy, please contact us at{' '}
                {SITE.supportEmail}.
              </Typography>
            </Paper>
          </Container>
        </Box>
        <Footer />
      </Box>
    </>
  );
}
